// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"styles_modalContent__IhEaI","modalClose":"styles_modalClose__Re59x","modalVideo":"styles_modalVideo__2glFL"};